/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
import React from "react";
import { Modal, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import Notice from "@assets/svg/CpDeliveryBoys/notice";

const ModalView = ({
  visible,
  dbs = [],
  switchDbId,
  isMultiTrip = false,
  onCloseSwitchDbModal,
  transferAllDeliveries,
}) => {
  const getDbName = (dbId) => {
    return dbs?.find((db) => db.id === dbId)?.db_name || "";
  };

  const newDbName = getDbName(switchDbId);

  return (
    <Modal transparent visible={visible} animationType="fade">
      <View style={styles.backdrop}>
        <View style={styles.container}>
          <View style={styles.icon}>
            <Notice />
          </View>
          <Text
            style={[
              styles.title,
              {
                color: "black",
                backgroundColor: "transparent",
                paddingHorizontal: 0,
              },
            ]}
          >
            {isMultiTrip
              ? switchDbId === "UNASSIGNED"
                ? `क्या आप इस रूट के जो कस्टमर अभी OFD नहीं हुए उन्हें unassign करना चाहते है? जो ऑर्डर OFD हो चुके हैं वो अभी वाले DB के पास ही रहेंगे।`
                : `क्या आप इस रूट के जो कस्टमर अभी OFD नहीं हुए उन्हें ${newDbName} को ट्रांसफर करना चाहते है? जो ऑर्डर OFD हो चुके हैं वो अभी वाले DB के पास ही रहेंगे।`
              : switchDbId === "UNASSIGNED"
                ? `क्या आप इस रूट की सभी डेलिवेरी unassign करना चाहते है?`
                : `क्या आप इस रूट की सभी डेलिवेरी ${newDbName} को ट्रांसफर करना चाहते है?`}
          </Text>

          <View style={styles.buttonRow}>
            <TouchableOpacity
              testID="switchcpdbleftbtn"
              style={[styles.ctaButton, { backgroundColor: "lightgray" }]}
              onPress={onCloseSwitchDbModal}
            >
              <Text style={[styles.ctaButtonText, { color: "#000" }]}>
                {"नहीं "}
              </Text>
            </TouchableOpacity>
            <View style={styles.spacer} />
            <TouchableOpacity
              testID="switchcpdbrightbtn"
              style={[
                styles.ctaButton,
                { backgroundColor: "rgba(0, 171, 89, 1)" },
              ]}
              onPress={transferAllDeliveries}
            >
              <Text style={[styles.ctaButtonText, { color: "#fff" }]}>
                {"हाँ "}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  backdrop: {
    backgroundColor: "rgba(0,0,0,0.8)",
    justifyContent: "center",
    flex: 1,
  },
  container: {
    marginHorizontal: 15,
    backgroundColor: "white",
    borderRadius: 20,
    position: "relative",
    paddingHorizontal: 20,
    paddingBottom: 20,
    paddingTop: 50,
  },
  title: {
    fontSize: 16,
    fontFamily: "NotoSansDevanagari-Bold",
    marginVertical: 8,
    alignSelf: "flex-start",
    paddingVertical: 4,
    borderRadius: 20,
  },

  ctaButton: {
    borderRadius: 8,
    flex: 1,
  },
  ctaButtonText: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    borderRadius: 8,
    fontSize: 16,
    textAlign: "center",
    paddingVertical: 6,
  },
  buttonRow: {
    marginTop: 16,
    flexDirection: "row",
  },
  spacer: {
    width: 12,
  },
  icon: {
    position: "absolute",
    top: -50,
    left: 24,
    height: 112,
    width: 112,
  },
});

export default ModalView;
